import React from "react";
import { FiImage } from "react-icons/fi";

export const TARGET_OPTIONS = [
  {
    value: "REPRESENTATIVES",
    label: "Meus representantes",
    badgeClass: "bg-emerald-100 text-emerald-800",
  },
  {
    value: "DIRECT_CLIENTS",
    label: "Meus clientes",
    badgeClass: "bg-indigo-100 text-indigo-800",
  },
];

export const TARGET_LOOKUP = TARGET_OPTIONS.reduce((acc, option) => {
  acc[option.value] = option;
  return acc;
}, {});

export const STATUS_CONFIG = {
  active: {
    label: "Ativo agora",
    badge: "bg-emerald-100 text-emerald-800",
  },
  upcoming: {
    label: "Programado",
    badge: "bg-amber-100 text-amber-900",
  },
  expired: {
    label: "Expirado",
    badge: "bg-slate-100 text-slate-600",
  },
  draft: {
    label: "Sem período definido",
    badge: "bg-slate-100 text-slate-600",
  },
};

export const getBannerStateKey = (startDate, endDate, now = Date.now()) => {
  const start = startDate ? new Date(startDate).getTime() : NaN;
  const end = endDate ? new Date(endDate).getTime() : NaN;
  if (!startDate || !endDate || Number.isNaN(start) || Number.isNaN(end)) {
    return "draft";
  }
  if (now < start) return "upcoming";
  if (now > end) return "expired";
  return "active";
};

export const formatDateTime = (value) => {
  if (!value) return "-";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "-";
  return parsed.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const BannerCard = ({ banner }) => {
  const statusKey = getBannerStateKey(banner.startDate, banner.endDate);
  const status = STATUS_CONFIG[statusKey] || STATUS_CONFIG.draft;
  const target = TARGET_LOOKUP[banner.targetAudience] || TARGET_OPTIONS[0];
  const bannerImage =
    banner.imagePreview || banner.imageSignedUrl || banner.imageUrl;
  const shouldShowTitle = banner.showTitle !== false;

  return (
    <article className="flex h-full flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-lg transition hover:-translate-y-1 hover:shadow-xl">
      <div className="relative h-40 overflow-hidden bg-gradient-to-br from-slate-900 to-slate-800">
        {bannerImage ? (
          <img
            src={bannerImage}
            alt={banner.title || "Banner corporativo"}
            className="h-full w-full object-cover"
          />
        ) : (
          <div className="flex h-full flex-col items-center justify-center gap-2 text-xs font-semibold uppercase tracking-[0.4em] text-slate-200">
            <FiImage className="text-2xl" />
            Sem imagem
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
        <div className="absolute inset-0 flex flex-col justify-between px-5 py-4">
          <span
            className={`self-start rounded-full px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.3em] text-slate-800 ${status.badge}`}
          >
            {status.label}
          </span>
          <span className="text-xs uppercase tracking-[0.4em] text-white/80">
            {target.label}
          </span>
        </div>
      </div>
      <div className="flex flex-1 flex-col gap-2 bg-white p-3">
        {shouldShowTitle && (
          <div className="space-y-1">
            <h3 className="text-base font-semibold leading-tight text-slate-900 line-clamp-2">
              {banner.title || "Título pendente"}
            </h3>
          </div>
        )}
        <p className="text-sm text-slate-600 line-clamp-2">
          {banner.description ||
            "Este banner ainda não possui descrição cadastrada."}
        </p>
        <div className="flex flex-wrap items-center justify-between gap-3 text-[12px] text-slate-500">
          <div className="flex flex-col">
            <span className="text-[10px] uppercase tracking-[0.4em] text-slate-400">
              Início
            </span>
            <span className="font-semibold text-slate-700">
              {formatDateTime(banner.startDate)}
            </span>
          </div>
          <div className="flex flex-col">
            <span className="text-[10px] uppercase tracking-[0.4em] text-slate-400">
              Fim
            </span>
            <span className="font-semibold text-slate-700">
              {formatDateTime(banner.endDate)}
            </span>
          </div>
        </div>
      </div>
    </article>
  );
};

export default BannerCard;
